"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTableSortIconWrapper = void 0;
var _TableSortIconWrapper = require("./TableSortIconWrapper");
// TODO: in v9, move styled() from TableSortIconWrapper.jsx to here
var StyledTableSortIconWrapper = _TableSortIconWrapper.TableSortIconWrapper;
exports.StyledTableSortIconWrapper = StyledTableSortIconWrapper;